"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initMetric = void 0;
var _generateUniqueID = require("./generateUniqueID");
var _getActivationStart = require("./getActivationStart");
var _getNavigationEntry = require("./getNavigationEntry");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var initMetric = exports.initMetric = function initMetric(name, value) {
  var navEntry = (0, _getNavigationEntry.getNavigationEntry)();
  var navigationType = 'navigate';
  if (navEntry) {
    if (window.document.prerendering || (0, _getActivationStart.getActivationStart)() > 0) {
      navigationType = 'prerender';
    } else {
      navigationType = navEntry.type.replace(/_/g, '-');
    }
  }
  return {
    name: name,
    value: typeof value === 'undefined' ? -1 : value,
    rating: 'good',
    // Will be updated if the value changes.
    delta: 0,
    entries: [],
    id: (0, _generateUniqueID.generateUniqueID)(),
    navigationType: navigationType
  };
};